import {Row,Col,Card, Container} from "react-bootstrap"
import {Link} from "react-router-dom"
import { pdfjs, Document, Page } from 'react-pdf';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

const Hello = () =>{

 

  return <div style={{padding:"2%"}}> 
  <h1>Hello, My name is:</h1>
  <p>A completely DIY module built around a generalised chain of inverting op amps... although it can be entirely passive</p>
  <p>The module has 2 units with 5 and 4 jacks respectively. Each jack can be routed to the positive input, negative input, and output of the circuits</p>

  <p>Through this architecture, we can make all sorts of useful circuits just by soldering some jumpers and through hole:</p>
  <p>fpr example, As an active circuit:</p>
  <ul>
    <li>Multiple</li>
    <li>Mixer</li>
    <li>Half/Full wave rectifier</li>
    <li>Comparators</li>
    <li>Filter banks</li>
    <li>Low pass gate (a bit tricky and TBC)</li>
    <li>Input/Output Amplifier</li>
    <li>soft clipper/overdrive</li>
  </ul>
  <p>It would not be hard to combine some of these functionalities to implement exactly what your system needs!</p>

  <p>There is enough circuitry here to insert your own short proteciton and anti-drooping - although that might depend on what you've designed</p>
  
  <p>Ignoring the op amp and power circuit we can make some passive circuits:</p>

  <ul>
    <li>Multiple</li>
    <li>Mixer</li>
    <li>R2R DAC (like <a href ="https://postmodular.co.uk/modules/olegtron-r2r/">olegtron</a>)</li>
  </ul>

  <h3>Parts</h3>

  <h3>Recipes</h3>

  <h3>specs</h3>
  <p>Width: 3HP (15.24mm)</p>
  <p>height: 3U (128.5mm)</p>
  <p>depth: TBC </p>
  <p>+12V current: Your problem </p>
  <p>-12V current: Your problem</p>
  {/* <img src={require("./HELLO_pcb.png")} style={{width:"100%"}}></img> */}

  </div>

}
export default Hello